export default "__VITE_ASSET__knQ4P0ra__"